/**
 * Export PCF Constants
 */
import type { ExportStatus, GroupBy } from './types';

export const EXPORT_COLUMN_PANEL_ID = 'export-pcf-manage-columns-panel';

/** Default column definitions for the export table */
export const DEFAULT_COLUMNS = [
  { id: 'piping-spec', label: 'PIPING-SPEC', checked: true, revitParameter: 'PiP_PPG_SPEC' },
  { id: 'material', label: 'MATERIAL', checked: true, revitParameter: 'PiX_03_Material_ENG' },
  { id: 'design-std', label: 'DESIGN-STD', checked: false, revitParameter: 'PiX_02_Standard_ENG' },
  { id: 'pressure-class', label: 'PRESSURE-CLASS', checked: false, revitParameter: 'PiX_PPG_END1_PressureRating' },
  { id: 'insulation-spec', label: 'INSULATION-SPEC', checked: false, revitParameter: 'PiX_GN_2_InsulationSpec' },
];

/** Grouping options for piping systems */
export const GROUP_BY_OPTIONS: { value: GroupBy; label: string; disabledReason?: string }[] = [
  { value: 'SystemName', label: 'System Name' },
  { value: 'SystemTypeName', label: 'System Type Name' },
  // Parameter grouping is suspended while its plugin-side pipeline issues are
  // resolved; the reason renders as a hover tooltip on the disabled radio.
  { value: 'Parameter', label: 'Parameter', disabledReason: 'Under construction' },
];

type StatusPaletteColor = 'info' | 'success' | 'warning' | 'error';

/** Status display configuration */
export const STATUS_CONFIG: Record<ExportStatus, { color: StatusPaletteColor; label: string }> = {
  NotValidated: { color: 'info', label: 'Not validated' },
  Ready: { color: 'success', label: 'Ready' },
  Warnings: { color: 'warning', label: 'Warnings' },
  Errors: { color: 'error', label: 'Errors' },
};
